import { MultiStepForm } from '../../../components';
import { useGenerateActivityReportJobContext } from '../../../context';
import { Steps } from 'react-step-builder';
import { PolicySelection } from '../components';
import { ActivityReportDateSelection } from '../../policy/components';
import { useHistory } from 'react-router-dom';

export default function ActivityReport() {
  const history = useHistory();
  const { startGenerateActivityReportJob, loading, error } = useGenerateActivityReportJobContext();
  const formSteps = [
    {
      name: 'Select Policy',
      initialValues: { policyId: null }
    },
    {
      name: 'Select Report Date Range',
      initialValues: { reportStartDate: null, reportEndDate: null, includeComplianceIntervals: false }
    }
  ];

  return (
    <MultiStepForm
      formSteps={formSteps}
      formSubmit={({ policyId, reportStartDate, reportEndDate, includeComplianceIntervals }) => {
        startGenerateActivityReportJob({ policyId, reportStartDate, reportEndDate, includeComplianceIntervals });
      }}
      maxWidth={'800px'}
      title={`Exposure Election Activity Report`}
      onCancel={() => history.push(`/reports`)}
      submitButtonText={'Generate Activity Report'}
      submitButtonProps={{ loading, loadingText: 'Generating Activity Report...' }}
      showButtonsOnBottom
      error={error}
    >
      {formProps => (
        <Steps>
          <PolicySelection {...formProps} />
          <ActivityReportDateSelection {...formProps} />
        </Steps>
      )}
    </MultiStepForm>
  );
}
